module.exports = __webpack_public_path__ + "img/g.f3fb77eb.jpg";